import { parseCampaignWizardPath } from '@/features/campaigns/lib/campaignWizardNavigation'
import { CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX } from '@/features/campaigns/lib/campaignWizardLayout'
import { QUESTION_BUILDER_PAGE_GUTTER_PX } from '@/features/instruments/question-builder/questionBuilderPageLayout'

const WORKSPACE_INSTRUMENT_PATH =
  /^\/instruments\/([^/]+)\/(?:builder|routing|publish)\/?/

export interface AppShellRouteFlags {
  isInstrumentCreatePicker: boolean
  isInstrumentCreateTemplates: boolean
  isInstrumentCreateInfo: boolean
  isInstrumentEditInfo: boolean
  showInstrumentCreateBack: boolean
  isQuestionBuilder: boolean
  isInstrumentRouting: boolean
  isPublish: boolean
  campaignWizardParsed: ReturnType<typeof parseCampaignWizardPath>
  isCampaignWizard: boolean
  showInstrumentWorkspaceHeader: boolean
  showCampaignWizardBack: boolean
  showAppShellInstrumentTitle: boolean
  isInstrumentWorkspaceGutterPage: boolean
  usesInstrumentPageGutter: boolean
  instrumentPageGutterPx: number
  workspaceInstrumentId: string
}

export function deriveAppShellRouteFlags(pathname: string): AppShellRouteFlags {
  const isInstrumentCreatePicker = pathname === '/instruments/create'
  const isInstrumentCreateTemplates = pathname === '/instruments/create/templates'
  const isInstrumentCreateInfo = pathname === '/instruments/create/info'
  const isInstrumentEditInfo =
    /^\/instruments\/[^/]+\/info\/?$/.test(pathname) &&
    !pathname.startsWith('/instruments/create/')
  const showInstrumentCreateBack =
    isInstrumentCreatePicker ||
    isInstrumentCreateTemplates ||
    isInstrumentCreateInfo ||
    isInstrumentEditInfo
  const isQuestionBuilder = /^\/instruments\/[^/]+\/builder\/?$/.test(pathname)
  const isInstrumentRouting = /^\/instruments\/[^/]+\/routing\/?$/.test(pathname)
  const isPublish = /^\/instruments\/[^/]+\/publish\//.test(pathname)
  const campaignWizardParsed = parseCampaignWizardPath(pathname)
  const isCampaignWizard = campaignWizardParsed != null
  const showInstrumentWorkspaceHeader =
    isQuestionBuilder || isInstrumentRouting || isPublish
  const showCampaignWizardBack = isCampaignWizard
  const showAppShellInstrumentTitle = isInstrumentRouting || isPublish
  const isInstrumentWorkspaceGutterPage = false
  const usesInstrumentPageGutter =
    isQuestionBuilder || isInstrumentRouting || isPublish || isCampaignWizard
  const instrumentPageGutterPx = isCampaignWizard
    ? CAMPAIGN_WIZARD_VERTICAL_GUTTER_PX
    : QUESTION_BUILDER_PAGE_GUTTER_PX
  const workspaceInstrumentIdMatch = WORKSPACE_INSTRUMENT_PATH.exec(pathname)
  const workspaceInstrumentId = workspaceInstrumentIdMatch?.[1] ?? ''

  return {
    isInstrumentCreatePicker,
    isInstrumentCreateTemplates,
    isInstrumentCreateInfo,
    isInstrumentEditInfo,
    showInstrumentCreateBack,
    isQuestionBuilder,
    isInstrumentRouting,
    isPublish,
    campaignWizardParsed,
    isCampaignWizard,
    showInstrumentWorkspaceHeader,
    showCampaignWizardBack,
    showAppShellInstrumentTitle,
    isInstrumentWorkspaceGutterPage,
    usesInstrumentPageGutter,
    instrumentPageGutterPx,
    workspaceInstrumentId,
  }
}
